import { defineStore } from "pinia";
import { computed, ref } from "vue";
import {
	ESignalCategories,
	ESignalIndicator,
	ESignalToken,
	ISignal,
	ISignals,
	SIGNALS_OUTPUT,
} from "@/shared";

export const useAutomationStore = defineStore("automation", () => {
	// data
	const signals = ref<ISignals>([]);
	const signalVariableRegex = /{signals\[([0-9]{1,})\].([a-zA-Z_]{1,})}/;

	// getters
	const getSignalsWithID = computed<ISignals>(() => {
		return signals.value.map((signal: ISignal, i: number) => ({
			...signal,
			id: i,
		}));
	});
	const getSignalByVariable = computed<
		(
			variable: string
		) => { signal: ISignal; field: string; label: string } | undefined
	>(() => (variable) => {
		const signalVariableRegex = /{signals\[([0-9]{1,})\].([a-zA-Z_]{1,})}/;

		if (!signalVariableRegex.test(variable)) return;

		const [_, signalIndex, field] = signalVariableRegex.exec(variable);
		const signal = getSignalsWithID.value[Number(signalIndex)];
		const [label] = SIGNALS_OUTPUT[signal.category][signal.type][field];

		return { signal, label, field };
	});

	return { signals, getSignalsWithID, signalVariableRegex, getSignalByVariable };
});
